var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3578 11.6674C13.3576 12.1094 13.1805 12.5332 12.8655 12.8456C12.5505 13.158 12.1233 13.3334 11.6781 13.3331C11.2328 13.3329 10.8058 13.1571 10.4911 12.8444C10.1764 12.5317 9.99978 12.1077 10 11.6657C10.0002 11.2237 10.1773 10.7999 10.4923 10.4875C10.8073 10.1752 11.2345 9.99978 11.6797 10C12.125 10.0002 12.552 10.176 12.8667 10.4887C13.1814 10.8014 13.358 11.2254 13.3578 11.6674ZM13.4082 14.5672H10.0504V25H13.4082V14.5672ZM18.7135 14.5672H15.3725V25H18.68V19.5253C18.68 16.4755 22.6842 16.1922 22.6842 19.5253V25H26V18.392C26 13.2507 20.0735 13.4423 18.68 15.9672L18.7135 14.5672Z",
    fill: "#006DC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLin);
export default __webpack_public_path__ + "static/media/lin.1738f89aee59ca559e34bfa0427e3389.svg";
export { ForwardRef as ReactComponent };